import React, { useEffect } from "react";
import ScrollReveal from "scrollreveal";
import VideoKyc from "./VideoKyc";

function FeaturesBenifits() {
  useEffect(() => {
    ScrollReveal().reveal(".one", {
      duration: 3000,
      reset: true,
      distance: "30px",
      origin: "left",
      easing: "cubic-bezier(0.5, 0, 0, 1)",
      mobile: false,
    });
    ScrollReveal().reveal(".two", {
      duration: 3000,
      reset: true,
      distance: "30px",
      origin: "right",
      easing: "cubic-bezier(0.5, 0, 0, 1)",
      mobile: false,
    });
    ScrollReveal().reveal(".three", {
      duration: 3000,
      reset: true,
      distance: "80px",
      origin: "top",
      easing: "cubic-bezier(0.5, 0, 0, 1)",
      mobile: false,
    });
    ScrollReveal().reveal(".four", {
      duration: 3000,
      reset: true,
      distance: "80px",
      origin: "bottom",
      easing: "cubic-bezier(0.5, 0, 0, 1)",
      mobile: false,
    });
  }, []);

  return (
    <>
      <section className="features_benifits">
        {/* <VideoKyc /> */}
        <div className="container">
          <h2 className="mb-4">Benefits</h2>
          <div className="row">
            <div className="col-lg-4 col-md-4 col-12 one">
              <div className="features_benifits_wrapper ">
                <div className="features_benifits_content ">
                  <h3>Digital Banking</h3>
                  <p>
                    Experience secure & seamless banking on-the-go with <b>iMobile App and Internet Banking</b> 
                  </p>
                </div>
                <div className="features_benifits_img">
                  <img
                    src="./dist/img/imobil.webp"
                    alt="imobile"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 three">
              <div className="features_benifits_wrapper odd">
                <div className="features_benifits_content pb-2">
                  <h3>Investments</h3>
                  <p>
                    Secure your future with easy investing in <b>FD, Mutual funds, stocks</b> and more, tailored as per your goals
                  </p>
                </div>
                <div className="features_benifits_img">
                  <img
                    src="./dist/img/fixed_deposit.webp"
                    alt="fixed deposit"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 two">
              <div className="features_benifits_wrapper ">
                <div className="features_benifits_content pb-2 pb-md-0">
                  <h3>Premium Cards</h3>
                  <p>
                    Earn rewards on every spend with our exclusive Credit Cards and use our Forex Card to fulfil your travel goals
                  </p>
                </div>
                <div className="features_benifits_img">
                  <img
                    src="./dist/img/credit_card.webp"
                    alt="credit card"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-12 one">
              <div className="features_benifits_wrapper odd">
                <div className="features_benifits_content mb-2">
                  {/* <h3>Pre-approved Loans</h3> */}
                  <h3>3 in 1 Account</h3>
                  {/* <p>
                    Enjoy paperless journey with instant sanction and disbursal to avail <b>Insta Loan, Personal Loan, Home Loan and Auto Loan</b>
                  </p> */}
                  <p>
                  Experience convenience of investing, monitoring and much more with the all in one Savings, Demat and Trading account.
                  </p>
                </div>
                <div className="features_benifits_img">
                  <img
                    src="./dist/img/pre_approved_loan.webp"
                    alt="pre-approved loan "
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>

            <div className="col-lg-4 col-md-4 col-12 four">
              <div className="features_benifits_wrapper">
                <div className="features_benifits_content">
                  <h3>Simplified Payments</h3>
                  <p>
                    Pay effortlessly using <b>UPI, Scan to Pay, Bills & Fund transfers</b> on your iMobile app
                  </p>
                </div>
                <div className="features_benifits_img">
                  <img
                    src="./dist/img/explore_offer.webp"
                    alt="explore offers"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
            <div className="col-lg-4 col-md-4 col-12 two">
              <div className="features_benifits_wrapper odd ">
                <div className="features_benifits_content">
                  <h3>Offers</h3>
                  <p>
                    <b>Explore exclusive offers</b> across lifestyle, shopping, dining, travel, entertainment, and more
                  </p>
                </div>
                <div className="features_benifits_img">
                  <img
                    src="./dist/img/digital_banking.webp"
                    alt="digital banking"
                    className="img-fluid"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default FeaturesBenifits;
